import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/systemRoles/systemRoles';
import Form from './Container';
import LoadMask from '../../Utils/LoadMask/LoadMask';

class Create extends Component {
    componentDidMount = () => {
        const { match, leer } = this.props;
        if (match.params.id) {
            const id = match.params.id;
            leer(id);
        }
    }

    render() {
        const { match, crear, editar, loader, location } = this.props;
        const id = match.params.id;
        const isEdit = location && location.pathname.includes('/editar');
        const isView = id && !isEdit;
        const isUpdate = id ? true : false;

        const handleSubmit = (data) => {
            if (isUpdate) {
                editar(id, data);
            } else {
                crear(data);
            }
        };

        return (
            <div className='d-flex flex-column w-100'>
                <div className='d-flex flex-wrap  justify-content-center'>
                    <div className='col-12 col-md-10 col-lg-8 card card-small p-4 mt-5'>
                        <div className='border-bottom pb-3 mb-3'>
                            <h3>
                                {isView ? 'Ver Rol de Sistema' : (isUpdate ? 'Editar Rol de Sistema' : 'Crear Rol de Sistema')}
                            </h3>
                        </div>
                        {loader && <LoadMask />}
                        <Form
                            onSubmit={handleSubmit}
                            isUpdate={isUpdate}
                            isView={isView}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const ms2p = (state) => {
    return {
        ...state.systemRoles,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Create);
